<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>∠A=∠B=∠C=∠D=90° | AC = BD$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(150, 60)">
            <path d="M 0 0 L 200 0 L 200 120 L 0 120 Z" fill="rgba(0, 210, 255, 0.15)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Right angles -->
            <rect x="0" y="0" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="1" />
            <rect x="185" y="0" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="1" />
            <rect x="0" y="105" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="1" />
            <rect x="185" y="105" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="1" />

            <!-- Diagonals -->
            <line x1="0" y1="0" x2="200" y2="120" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />
            <line x1="200" y1="0" x2="0" y2="120" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>矩形性质：</strong>有一个角是直角的平行四边形。四个角都是直角，对边平行且相等，对角线相等且互相平分。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RectangleViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>